export default __webpack_public_path__ + "static/media/d7.fd8ed0ef.jpg";